module.exports = __webpack_public_path__ + "img/album21_05.2fc92802.jpg";